import { useMountEffect } from "@react-hookz/web";
import { isBrowser } from "@react-hookz/web/cjs/util/const";
import { useState } from "react";
import { playSilentAudio } from "util/playSilentAudio";

let _audioCtx: AudioContext;
let readyStore = {
  _isReady: false,
  _subscriptions: [] as ((isReady: boolean) => void)[],

  get isReady() {
    return this._isReady;
  },

  set isReady(value) {
    if (value === this._isReady) {
      return;
    }

    this._isReady = value;
    this._subscriptions.forEach((cb) => cb(value));
  },

  subscribe(cb: (isReady: boolean) => void) {
    this._subscriptions.push(cb);
  },
};

// autostart
(() => {
  if (!isBrowser) {
    return;
  }

  _audioCtx = new AudioContext();

  const listener = () => {
    _audioCtx.resume().then(() => {
      readyStore.isReady = true;
    });

    document.removeEventListener("click", listener);
  };

  document.addEventListener("click", listener);

  const silentAudioListener = () => {
    playSilentAudio();

    document.removeEventListener("click", silentAudioListener);
  };

  document.addEventListener("click", silentAudioListener);

  _audioCtx.onstatechange = () => {
    readyStore.isReady = _audioCtx.state === "running";
  };
})();

export function useAudioContextReady() {
  const [ready, setReady] = useState(true);

  useMountEffect(() => {
    if (readyStore.isReady !== ready) {
      setReady(readyStore.isReady);
    }

    readyStore.subscribe(setReady);
  });

  return [
    ready,
    () => {
      _audioCtx.resume().then(() => {
        setReady(true);
      });
    },
  ] as const;
}

export const audioCtx = () => {
  return _audioCtx;
};
